import React from 'react';
import PropTypes from 'prop-types';
import { QuantityInput, CheckStockButton, AddToBasketButton, ViewBasketButton } from '../';

export default class CheckStockModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      quantity: this.props.initialQuantity,
      articleAvailability: null,
      hasBeenAddedToBasket: false,
    };

    this.iconClasses = {
      Green: 'icon-rs_57-tick',
      Amber: 'icon-rs_37-info',
      Red: 'icon-rs_61-warning',
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.addedToBasket = this.addedToBasket.bind(this);
  }

  handleChange(quantity) {
    this.setState({
      quantity,
    });
  }

  handleClick(articleAvailability) {
    this.setState({
      articleAvailability,
      quantity: Boolean(articleAvailability) === true ? articleAvailability.roundedQuantity : 0,
      hasBeenAddedToBasket: false,
    });
  }

  addedToBasket() {
    this.setState({
      hasBeenAddedToBasket: true,
    });
    if (this.props.onAddToBasket) {
      this.props.onAddToBasket(this.state.quantity);
    }
  }

  render() {
    const availability = this.state.articleAvailability;
    return (
      <div className="stocklevel-container">
        <div className="description">{this.props.labels.checkStockHelpText}</div>
        <div className="stock-number">{this.props.labels.stockNumber}<label htmlFor="check-quantity">{this.props.stockNumber}</label></div>
        {
          availability && Object.keys(availability).length > 0 &&
          availability.displayRoundedMessage &&
          <div className="rounded-message">{availability.roundedMessage}</div>
        }
        <div className="interactive-container">
          <span>{this.props.labels.lookingForText}</span>&nbsp;
          <QuantityInput
            className="check-quantity"
            value={this.state.quantity}
            maximumQuantity={this.props.maximumQuantity}
            onChangeHandler={this.handleChange}
          />&nbsp;
          <CheckStockButton
            label={this.props.labels.checkStock}
            productNumber={this.props.productNumber}
            productId={this.props.productId}
            quantity={this.state.quantity}
            onCheckStock={this.handleClick}
          />
        </div>
        {
          availability && Object.keys(availability).length > 0 &&
          <div className="bottom-content">
            { !this.state.hasBeenAddedToBasket &&
              <span>
                <div className="stock-content content-row">
                  <div className="atp-message-container">
                    {
                      availability.promiseBannerMessage &&
                      <span>
                        <div className="dtp-message-container dtp-stock-warning">
                          <div className="dtpFormattedMessage">
                            {availability.promiseBannerMessage}
                          </div>
                        </div>
                        <br />
                      </span>
                    }
                    {
                      availability.promiseMessage &&
                      <div className="dtp-message-container">
                        <span>
                          <div className={(availability.promiseStatusCode === 'ERROR' || availability.promiseStatusCode === null) ? 'dtp-results-error' : 'dtp-results'}>
                            <span className={`dtp-stock-badge dtp-stock-badge-${availability.promiseStatusCode}`}>
                              <img src={availability.promiseBadgeIcon} alt={availability.promiseStatusCode} className="dtp-stock-level-icon" />
                              <span className="dtpFormattedMessage">
                                {
                                  availability.promiseMessage.map(part => {
                                    return (<span className={part.name}>{part.value}</span>);
                                  })
                                }
                              </span>
                            </span>
                          </div>
                          <div>
                            <ul className="dtp-stock-promise dtp-stockcheck-schedules">
                              {
                                availability.promiseSchedules.map(scheduleMessageParts => {
                                  return (<li>
                                    {
                                      scheduleMessageParts.map(part => {
                                        return (<span className={part.name}>{part.value}</span>);
                                      })
                                    }
                                  </li>);
                                })
                              }
                            </ul>
                          </div>
                        </span>
                      </div>
                    }
                    {
                      !availability.promiseMessage && availability.availabilityMessageTO.availabilityHeaderMessage &&
                      <div className="atp-message atp-partial-stock Green">
                        <div className="atp-header">
                          <i className="icon icon-rs_57-tick" aria-hidden="true" />
                          <span className="atp-text">
                            {availability.availabilityMessageTO.headerQuantity} {availability.availabilityMessageTO.availabilityHeaderMessage}
                          </span>
                        </div>
                      </div>
                    }
                    {
                      !availability.promiseMessage && availability.availabilityMessageTO.partialStockStatusMessageTO.map(item => {
                        return (<div
                          key={item.availabilityIndicator}
                          className={` ${availability.availabilityMessageTO.availabilityHeaderMessage !== null ?
                            'sub' : 'atp-message'} ${item.atpIcon} `}
                        >
                          <i
                            className={`icon ${availability.availabilityMessageTO.availabilityHeaderMessage === null ?
                              this.iconClasses[item.atpIcon] : null} `}
                            aria-hidden="true"
                          />
                          <span className="atp-text">
                            {item.quantity} {item.availabilityMessage}
                          </span>
                        </div>);
                      })
                    }
                    {
                      !availability.promiseMessage && availability.availabilityMessageTO.nonPartialStockStatusMessageTO.map(item => {
                        return (<div key={item.availabilityIndicator} className={`atp-message ${item.atpIcon}`}>
                          <i
                            className={`icon ${this.iconClasses[item.atpIcon]}`}
                            aria-hidden="true"
                          />
                          <span className="atp-text">
                            {item.quantity} {item.availabilityMessage}
                          </span>
                        </div>);
                      })
                    }
                  </div>
                  <div className="btn-container">
                    <AddToBasketButton
                      stockNumber={this.props.stockNumber}
                      quantity={this.state.quantity}
                      label={`Add ${this.state.articleAvailability.roundedQuantity}`}
                      isLarge={false}
                      onAddedToBasket={this.addedToBasket}
                      disabled={availability.promiseNoAddToCart}
                    />
                  </div>
                </div>
              </span>
            }
            {
              this.state.hasBeenAddedToBasket &&
                <div className="cart-result content-row">
                  <div>
                    <button className="btn btn-default btn-shopping" onClick={this.props.closeModal}>{this.props.labels.continueShopping}</button>
                    <ViewBasketButton label={this.props.labels.checkout} redirectUrl={this.props.basketUrl} className={'float-right'} />
                    <div className="cart-added stock-check-cart-added">
                      <i className="icon icon-rs_57-tick" aria-hidden="true" /><span>{this.props.labels.added}</span>
                    </div>
                  </div>
                  <div className="clr" />
                </div>
            }
          </div>
        }
      </div>
    );
  }
}

CheckStockModal.propTypes = {
  stockNumber: PropTypes.string,
  productNumber: PropTypes.string,
  productId: PropTypes.string,
  initialQuantity: PropTypes.number.isRequired,
  labels: PropTypes.shape({
    checkStockHelpText: PropTypes.string,
    stockNumber: PropTypes.string,
    lookingForText: PropTypes.string,
    checkStock: PropTypes.string,
    addToCart: PropTypes.string,
    continueShopping: PropTypes.string,
    checkout: PropTypes.string,
    added: PropTypes.string,
  }),
  maximumQuantity: PropTypes.number.isRequired,
  closeModal: PropTypes.func,
  basketUrl: PropTypes.string,
  onAddToBasket: PropTypes.func,
};

CheckStockModal.defaultProps = {
  stockNumber: '',
  productNumber: '',
  productId: '',
  labels: {},
  closeModal: null,
  basketUrl: '',
  onAddToBasket: null,
};



// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/components/CheckStock/CheckStockModal.js